// Google Analytics (GA4) loaded only after the visitor accepts analytics
// cookies. PECR requires consent before non-essential cookies are set, so the
// gtag script must never be in public/index.html.

export const GA_MEASUREMENT_ID = 'G-W47QQVRM7Y';
const CONSENT_KEY = 'rebelheat_analytics_consent'; // 'granted' | 'denied'
const CONSENT_EVENT = 'rebelheat:consent-reset';

export function getConsent() {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch {
    return null;
  }
}

function storeConsent(value) {
  try {
    localStorage.setItem(CONSENT_KEY, value);
  } catch {
    // Storage blocked: the banner will simply ask again next visit.
  }
}

let loaded = false;

export function loadAnalytics() {
  if (loaded || getConsent() !== 'granted') return;
  loaded = true;
  window[`ga-disable-${GA_MEASUREMENT_ID}`] = false;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  // The first page_view is sent by trackPageView from App.js.
  window.gtag('config', GA_MEASUREMENT_ID, { send_page_view: false });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);
}

export function trackPageView(path) {
  if (getConsent() !== 'granted' || typeof window.gtag !== 'function') return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
  });
}

export function acceptAnalytics() {
  storeConsent('granted');
  loadAnalytics();
  trackPageView(window.location.pathname + window.location.search);
}

export function declineAnalytics() {
  storeConsent('denied');
  window[`ga-disable-${GA_MEASUREMENT_ID}`] = true;
  // Remove any GA cookies set under an earlier "accept".
  document.cookie.split(';').forEach((c) => {
    const name = c.split('=')[0].trim();
    if (name === '_ga' || name.startsWith('_ga_')) {
      const expire = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
      document.cookie = expire;
      document.cookie = `${expire}; domain=.${window.location.hostname.replace(/^www\./, '')}`;
    }
  });
}

// Lets the privacy page reopen the banner so visitors can change their mind.
export function resetConsent() {
  try {
    localStorage.removeItem(CONSENT_KEY);
  } catch {
    // ignore
  }
  window.dispatchEvent(new Event(CONSENT_EVENT));
}

export function onConsentReset(handler) {
  window.addEventListener(CONSENT_EVENT, handler);
  return () => window.removeEventListener(CONSENT_EVENT, handler);
}
